module.exports = __webpack_public_path__ + "img/top-right-corner.3a205ec7.svg";